import React, {useEffect, useState} from "react";
import {Chip, Typography} from "@material-tailwind/react";
import persianNumberFormat from "../../helper/PersianNumberFormat";
import Dict from "../../helper/dict";

const WalletReservation = ({reserves}) => {

  const [reserveList, setReserveList] = useState(reserves?.length > 0 ? reserves : null);

  useEffect(() => {
    setReserveList(reserves)
  }, [reserves]);

  return (
    <>
      {reserveList && reserveList.length > 0 &&
        reserveList.map(({type, field_title, branch_title, date, price}, index) => (
          <div
            key={index}
            className="flex flex-col justify-between pb-3 pt-3 border-b-2 last:pb-0"
          >
            <Chip
              variant="ghost"
              className="flex-row max-w-fit"
              color={type === "consultation" ? "blue" : "teal"}
              size="sm"
              value={Dict(`${type}`)}
            />
            <div className="flex flex-row">
              <Typography color="blue-gray" variant="h6">
                {field_title + " - " + branch_title}
              </Typography>
            </div>
            <div className="flex flex-row justify-between">
              <div>
                <Typography variant="small" color="gray">
                  {persianNumberFormat(date)}
                </Typography>
              </div>
              <div>
                <Typography color="blue-gray" variant="h6">
                  {persianNumberFormat(price, true) + " ریال"}
                </Typography>
              </div>
            </div>


          </div>
        ))}
      {reserveList && reserveList.length === 0 &&
        <>
          <Typography color="gray" className="textCenter">
            رزرو فعالی ندارید
          </Typography>
        </>

      }
    </>
  );
};

export default WalletReservation;
